// extracted by mini-css-extract-plugin
export default {"textareaFilterDesc":"Textarea__textareaFilterDesc___rJMJe","textareaFilter":"Textarea__textareaFilter___qvzPh"};